/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize CorrelationRiskRateProgression List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './CorrelationRiskRateProgressionListView';

export const mapStateToPropsCorrelationRiskRateProgressionList =
  mapStateToProps;
export const mapDispatchToPropsCorrelationRiskRateProgressionList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsCorrelationRiskRateProgressionList,
  mapDispatchToPropsCorrelationRiskRateProgressionList
)(View);
